import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "appliances-table-appliance__mobile-card d-flex d-md-none flex-column" }
const _hoisted_2 = { class: "top d-flex justify-content-between" }
const _hoisted_3 = { class: "callsign" }
const _hoisted_4 = { class: "status d-flex align-items-center" }
const _hoisted_5 = { class: "mid" }
const _hoisted_6 = {
  key: 0,
  class: "bot d-flex justify-content-start align-items-center"
}
const _hoisted_7 = { class: "incident" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = { class: "icad-num" }
const _hoisted_10 = {
  key: 1,
  class: "actions d-flex justify-content-between"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "callsign col-2" }
const _hoisted_14 = { class: "status d-flex align-items-center col-2" }
const _hoisted_15 = { class: "tag d-flex justify-content-center align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "updated col-2" }
const _hoisted_18 = { class: "incident d-flex justify-content-start align-items-center col-2" }
const _hoisted_19 = { class: "type" }
const _hoisted_20 = { class: "icad-num col-2" }
const _hoisted_21 = {
  key: 0,
  class: "actions d-flex justify-content-between col-2"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationTag = _resolveComponent("NotificationTag")!
  const _component_IncidentIcon = _resolveComponent("IncidentIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_IncidentPopover = _resolveComponent("IncidentPopover")!
  const _component_LocationPopover = _resolveComponent("LocationPopover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["appliances-table-appliance", _ctx.topClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.callSignCode), 1),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.kCodeStatus) + " ", 1),
          _createVNode(_component_NotificationTag, {
            extraClass: 'tag',
            value: _ctx.kCodeIdentifier,
            colorType: _ctx.topClass
          }, null, 8, ["value", "colorType"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.updatedTimestamp), 1),
      (_ctx.eventTypeDescription && _ctx.cadNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_IncidentIcon, {
              type: _ctx.eventTypeCode,
              class: "icon"
            }, null, 8, ["type"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.eventTypeDescription), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.cadNumber), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.mapLink || _ctx.reportLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "map-button",
              href: _ctx.mapLink
            }, "Map", 8, _hoisted_11),
            _createElementVNode("button", {
              class: "report-button",
              href: _ctx.reportLink
            }, "Report", 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["appliances-table-appliance__desktop-row d-none d-md-flex flex-md-row align-items-center row", { grey: _ctx.oddKey }])
    }, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.callSignCode), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.kCodeIdentifier), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.kCodeStatus) + " ", 1),
        (_ctx.showLocationData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, {
                icon: "comment-alt",
                class: "location-icon",
                id: "locationIcon"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.updatedTimestamp), 1),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_IncidentIcon, {
          type: _ctx.eventTypeCode,
          class: "icon",
          id: "incidentIcon"
        }, null, 8, ["type"]),
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.eventTypeDescription), 1)
      ]),
      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.cadNumber), 1),
      (_ctx.mapLink || _ctx.reportLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "map-button",
              href: _ctx.mapLink
            }, "Map", 8, _hoisted_22),
            _createElementVNode("button", {
              class: "report-button",
              href: _ctx.reportLink
            }, "Report", 8, _hoisted_23)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.cadNumber)
      ? (_openBlock(), _createBlock(_component_IncidentPopover, {
          key: 0,
          heading: "F2998245 - Smell of electrical burning pers reported - TX 2nd alarm",
          units: "Assigned Units: 6 | Max: 10",
          tag: _ctx.callSignCode,
          attending: "K2 in Attendance",
          targetId: "incidentIcon",
          id: "tooltip",
          class: "d-none",
          ref: "popupRef"
        }, null, 8, ["tag"]))
      : _createCommentVNode("", true),
    _createVNode(_component_LocationPopover, {
      heading: "Location",
      location: "@ Placeholder Station",
      targetId: "locationIcon",
      id: "tooltip",
      class: "d-none",
      ref: "popupRef"
    }, null, 512)
  ], 2))
}